/* v8 ignore start */
const SUB_LOCATIONS_MAP = Object.freeze({
  gh: [
    "In Client's Room",
    "1st Floor",
    "1st Floor Bathroom",
    "1st Floor Landing Meds Room",
    "1st Floor Stairs",
    "2nd Floor",
    "2nd Floor Shower Room",
    "2nd Floor Stairs",
    "Back Stairs",
    "Basement Office",
    "Basement",
    "Car Park",
    "Conservatory",
    "Court Yard",
    "Dining Room",
    "Entrance Porch",
    "Garden Room",
    "Garden Toilet",
    "Ground Floor",
    "Ground Floor Shower Room",
    "Ground Floor Toilet",
    "Hallway",
    "Main House Lift",
    "Main Lounge",
    "Main Patio",
    "New Block",
    "New Lounge",
    "Quiet Lounge",
    "Quiet Lounge Patio",
    "Rear Garden",
    "Rear Garden Smoking Shelter",
    "Staff Room",
    "The Chapel",
  ],
  mf: [
    "In Client's Room",
    "Activity Room",
    "Bottom Outside Lift",
    "Bottom Steps",
    "Bottom Terrace",
    "Car Park",
    "Communal Bathroom",
    "Corridor Sun Lounge",
    "Dining Room",
    "Hallway",
    "Laundry",
    "Middle Landing",
    "Middle Steps",
    "Middle Terrace",
    "Residents Kitchen",
    "Smoking Shelter",
    "Sun Terrace",
    "Sunroom",
    "Top Corridor",
    "Top Garden",
    "Top Landing",
    "Top Outside Lift",
  ],
});

const getSubLocations = (locationId) => {
  return SUB_LOCATIONS_MAP[locationId] || [];
};

export default getSubLocations;
/* v8 ignore stop */
